import CatchAllSlugPage from "../src/next/catchAll/CatchAllSlugPage";
import { buildMetadataByPath } from "../lib/seo/metadata";
import { buildHomeSeoServerContent } from "../lib/seo/homeServerContent";

export default CatchAllSlugPage;

import { getLanguageHost } from "../src/shared/localeRouting";

/** Host production tương ứng ngôn ngữ worker (vi/tiền tố → apex, ja → ja.qrcode-gen.com) */
function workerHostForLanguage(lang) {
  return getLanguageHost(lang || "vi");
}

export async function getStaticPaths() {
  return {
    paths: [{ params: { slug: false } }],
    fallback: false
  };
}

export async function getStaticProps() {
  // WORKER_SSR_HOST / WORKER_DEFAULT_LANGUAGE do wrangler-build-worker.js set — ưu tiên hơn .env (vd DEFAULT_LANGUAGE=vi)
  const lang =
    process.env.WORKER_DEFAULT_LANGUAGE ||
    process.env.REACT_APP_DEFAULT_LANGUAGE ||
    process.env.DEFAULT_LANGUAGE ||
    "vi";
  const host = process.env.WORKER_SSR_HOST || workerHostForLanguage(lang);
  const metadata = await buildMetadataByPath("/", host, lang);
  const serverContent = buildHomeSeoServerContent(metadata);

  return {
    props: {
      pathname: "/",
      metadata,
      serverContent
    }
  };
}
